export const routes = {
  HOME: "/",
  ABOUT: "/about",
  NO_PAGE_FOUND: "/no-page",
  AUTH: "/auth",
  START_PARTY: "/start-party",
  SELECT_VIDEO: "/select-video",
  CREATE_ROOM: "/create-room",
  CREATE_LINK_FOR_LATER: "/create-link-for-later",
  SELECT_STREAMING_SERVICE: "/select-streaming-service",
  JOIN_ROOM: "/join-room",
};
